import { createAction } from 'redux-actions';
import { reduxKey } from './constants';

export const fetchNext = createAction(
  `${reduxKey}/FETCH_NEXT`,
  (streamId: string) => ({ streamId })
);
